import {
  get_px8ok5q0jdway2 as get_px,
  get_rem2p56fiaxda5jo as get_rem,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import { GenericDialog2kroovzplfo3s as GenericDialog } from './GenericDialog.mjs';
import { ClientPaymentInfo323a5wacn9ntp as ClientPaymentInfo } from '../screens/client/ClientProject.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__toFullString_impl_igjjwy52pd76w4j0ou as MonetaryValue__toFullString_impl_igjjwy,
} from '../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import {
  PaymentTransferMethod_TwoThreeDay_getInstanceq532502amdnm as PaymentTransferMethod_TwoThreeDay_getInstance,
  PaymentTransferMethod_SameDay_getInstance1esd8e6oetmaq as PaymentTransferMethod_SameDay_getInstance,
} from '../../../../../crowpay-shared/com/crowpay/paymentModels.mjs';
import { confirmationDialog1lynowl7yd4cd as confirmationDialog } from './GenericConfirmationDialog.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  Semanticpmpmvt7fldq2 as Semantic,
  UnselectedSemantic_getInstancexnnq5hq6ryv2 as UnselectedSemantic_getInstance,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  CompactSemantic_getInstance287c07xso9hna as CompactSemantic_getInstance,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  AffirmativeSemantic_getInstance3qy0l8mucaq7h as AffirmativeSemantic_getInstance,
  FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { LightSection_getInstance1p9fz392synu9 as LightSection_getInstance } from '../theming/sections.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../theming/AppColors.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_bold1rri6ahk98puv as get_bold,
  get_compact3lsezez8nz8b6 as get_compact,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atTopEnd21ub47e8cwtv6 as get_atTopEnd,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  resize3py5p2yrjp6p7 as resize,
  Action1a4ymn5nx79hk as Action,
} from '../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import {
  boldSubTitle1bjbn9bt8inbw as boldSubTitle,
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  title1nssp3ryhwuqj as title,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
  body3i5t0n7zprpqb as body,
} from '../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { colored3y8uibz1hk46 as colored } from '../theming/colorManagement.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../theming/separators.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { NothingHereSemantic_getInstance3tro8v94k1jgs as NothingHereSemantic_getInstance } from '../theming/appTheme.mjs';
import { Companion_getInstance2a03ktg5l3ejl as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  get_bank374yxon6d2xhn as get_bank,
  get_lightningBolt25n67cdauhg6i as get_lightningBolt,
} from '../../icons.mjs';
import { GreyedOutSemantic_getInstancexltt5xem3a07 as GreyedOutSemantic_getInstance } from '../theming/states.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../sdk/UserSession.mjs';
import { get_fullName2ompl3bj5l3sh as get_fullName } from '../../../../../crowpay-shared/com/crowpay/extensions/User.ext.shared.mjs';
import { Request3h9l52knfhl5u as Request } from '../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { mutableRemember1h6fyyolumj0o as mutableRemember } from '../../../../../reactive/com/lightningkite/reactive/core/MutableRemember.mjs';
import { validatedmmpm5lnzq3lm as validated } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/entrypoints.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_namefvrph831c91t as get_name,
  get_address1quoosiozsuan as get_address,
} from '../../../../../crowpay-shared/com/crowpay/RequestFields.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import { assertNotBlank3rcqh0n27fq5q as assertNotBlank } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { validategsg6go7eyi9d as validate } from '../../utils/validation.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import { get_issues1z1skb5sgeygq as get_issues } from '../../../../../reactive/com/lightningkite/reactive/lensing/validation/Validated.mjs';
import { issueText2dqtp9rg036jt as issueText } from '../../../../../kiteui-library/com/lightningkite/kiteui/reactive/validation.mjs';
import { addressForm32k03uh8crpev as addressForm } from '../components/addressForm.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  get_primaryButton2lywrys4ffv1i as get_primaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
} from '../theming/buttons.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function CollectFundsThroughDirectDepositDialog$TransferMethod$default$lambda($this$to, it) {
  return it.ab1_1;
}
function CollectFundsThroughDirectDepositDialog$TransferMethod$default$lambda_0($this$to, it) {
  return $this$to.hd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, get_px(2));
}
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = $this.vi7_1.ti7_1.wi7($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  $this.xi7_1.mam(true);
  var tmp = $this.yi7_1.ti7_1.zi7($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  $this.xi7_1.mam(false);
  var tmp_0 = $this.yi7_1.ti7_1;
  if (tmp_0 instanceof ClientPaymentInfo()) {
    get_dialogStack().ugg();
    var tmp_1 = get_dialogStack();
    tmp_1.xgd(GenericDialog().bgh('Disbursement Requested', 'Your request has been submitted. You will receive a confirmation email with details. Your funds will be deposited within 2-3 business days.', VOID, CollectFundsThroughDirectDepositDialog$render$slambda$slambda$slambda_0()));
  } else {
    get_dialogStack().ugg();
  }
  return Unit_instance;
}
var CollectFundsThroughDirectDepositDialog$render$slambda$slambda$slambdaClass;
function CollectFundsThroughDirectDepositDialog$render$slambda$slambda$slambda() {
  if (CollectFundsThroughDirectDepositDialog$render$slambda$slambda$slambdaClass === VOID) {
    class $ {
      wgg($this$GenericDialog, $completion) {
        get_dialogStack().ugg();
      }
      s2(p1, $completion) {
        return this.wgg(p1 instanceof ViewWriter() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CollectFundsThroughDirectDepositDialog$render$slambda$slambda$slambdaClass = $;
  }
  return CollectFundsThroughDirectDepositDialog$render$slambda$slambda$slambdaClass;
}
function CollectFundsThroughDirectDepositDialog$render$slambda$slambda$slambda_0() {
  var i = new (CollectFundsThroughDirectDepositDialog$render$slambda$slambda$slambda())();
  var l = ($this$GenericDialog, $completion) => i.wgg($this$GenericDialog, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_1($this, $this$Action, $completion) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().d1();
  var tmp = MonetaryValue__toString_impl_xslc77($this.bi8_1.si7_1);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.bi8_1.di8();
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp0_safe_receiver = tmp_0;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
  this_0.wb(tmp + ' will be deposited to your account "' + (tmp1_safe_receiver == null ? null : tmp1_safe_receiver.a9v_1) + '". ');
  if ($this.bi8_1.ui7_1.f2().equals(PaymentTransferMethod_TwoThreeDay_getInstance())) {
    this_0.wb('Funds typically arrive within 2-3 business days.');
  }
  var tmp_1 = this_0.toString();
  confirmationDialog($this.ai8_1, 'Confirm Direct Deposit', tmp_1, 'Confirm', VOID, VOID, VOID, false, VOID, VOID, CollectFundsThroughDirectDepositDialog$render$slambda$slambda_0($this.ci8_1, $this.bi8_1));
  return Unit_instance;
}
var CollectFundsThroughDirectDepositDialog$render$slambda$slambdaClass;
function CollectFundsThroughDirectDepositDialog$render$slambda$slambda() {
  if (CollectFundsThroughDirectDepositDialog$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor($inProgress, this$0) {
        this.xi7_1 = $inProgress;
        this.yi7_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CollectFundsThroughDirectDepositDialog$render$slambda$slambdaClass = $;
  }
  return CollectFundsThroughDirectDepositDialog$render$slambda$slambdaClass;
}
function CollectFundsThroughDirectDepositDialog$render$slambda$slambda_0($inProgress, this$0) {
  var i = new (CollectFundsThroughDirectDepositDialog$render$slambda$slambda())($inProgress, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.ei8_1.ui7_1.gah($this.fi8_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var TransferMethodClass;
function TransferMethod() {
  if (TransferMethodClass === VOID) {
    class $ extends Semantic() {
      static hi8() {
        TransferMethod_instance = null;
        var $this = this.bd1('trsnfr');
        TransferMethod_instance = $this;
        return $this;
      }
      cd1(theme) {
        var tmp = theme.db1(LightSection_getInstance()).eb1_1;
        var tmp_0 = AppColors_getInstance().dfz_1.xg9_1;
        var tmp_1 = get_px(0);
        var tmp_2 = UnselectedSemantic_getInstance();
        var tmp_3 = to(tmp_2, CollectFundsThroughDirectDepositDialog$TransferMethod$default$lambda);
        var tmp_4 = SelectedSemantic_getInstance();
        return this.hd1(tmp, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, mapOf([tmp_3, to(tmp_4, CollectFundsThroughDirectDepositDialog$TransferMethod$default$lambda_0)]));
      }
    }
    initMetadataForObject($, 'TransferMethod');
    TransferMethodClass = $;
  }
  return TransferMethodClass;
}
var TransferMethod_instance;
function TransferMethod_getInstance() {
  if (TransferMethod_instance === VOID)
    TransferMethod().hi8();
  return TransferMethod_instance;
}
function render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option_ieysnz(_this__u8e3s4, this$0, option, icon_0, name, description, enabled) {
  var tmp = _this__u8e3s4.hbb(TransferMethod_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
  var tmp$ret$0 = _this__u8e3s4.hbb(ButtonSemantic_getInstance());
  var tmp_0 = _this__u8e3s4.ibb(tmp, tmp$ret$0);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var tmp_1 = KMutableProperty0();
  var tmp_2 = Button$_get_enabled_$ref_61t7nx_0(view);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('enabled', 0, tmp_1, tmp_2, Button$_set_enabled_$ref_o8kynz_0(view));
  var actionToCalculate = enabled;
  reactiveScope(view, ($this$reactiveScope) => {
    this_0.set(actionToCalculate($this$reactiveScope));
    return Unit_instance;
  });
  dynamicTheme(view, ($this$dynamicTheme) => $this$dynamicTheme.baj(this$0.ui7_1).equals(option) ? SelectedSemantic_getInstance() : null);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  view_0.zb8(view_0.kba().db1(CompactSemantic_getInstance()).eb1_1.hb0_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(false);
  view_1.jbb(get_centered(view_1), icon(view_1, resize(icon_0, get_AppDimensions().tg1_1), 'bank'));
  view_1.jbb(get_centered(view_1), boldSubTitle(view_1, name));
  view_0.fbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.xbm(false);
  var tmp_3 = get_centered(view_2);
  var tmp_4 = resize(icon_0, get_AppDimensions().tg1_1);
  view_2.jbb(tmp_3, icon(view_2, tmp_4, 'bank', CollectFundsThroughDirectDepositDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option$lambda_eyqlxo));
  var tmp_5 = get_centered(view_2);
  // Inline function 'com.crowpay.views.theming.subTitle' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  view_3.jba(view_3.ob6_1.ybe(SubtitleSemantic_getInstance()));
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_6 = view_3.tb5_1;
  var tmp_7;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(description) === 0) {
    tmp_7 = '\xA0';
  } else {
    tmp_7 = description;
  }
  tmp_6.fbu(tmp_7);
  view_2.fbb(p_3, view_3);
  view_2.jbb(tmp_5, view_3);
  view_0.fbb(p_2, view_2);
  view.fbb(p_0, view_0);
  onClick(view, VOID, VOID, CollectFundsThroughDirectDepositDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option$slambda_zhbtf_0(this$0, option));
  _this__u8e3s4.fbb(p, view);
  _this__u8e3s4.jbb(tmp_0, view);
}
var CollectFundsThroughDirectDepositDialog$render$slambdaClass;
function CollectFundsThroughDirectDepositDialog$render$slambda() {
  if (CollectFundsThroughDirectDepositDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CollectFundsThroughDirectDepositDialog$render$slambdaClass = $;
  }
  return CollectFundsThroughDirectDepositDialog$render$slambdaClass;
}
function CollectFundsThroughDirectDepositDialog$render$slambda_0() {
  var i = new (CollectFundsThroughDirectDepositDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var CollectFundsThroughDirectDepositDialog$render$slambdaClass_0;
function CollectFundsThroughDirectDepositDialog$render$slambda_1() {
  if (CollectFundsThroughDirectDepositDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.vi7_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CollectFundsThroughDirectDepositDialog$render$slambdaClass_0 = $;
  }
  return CollectFundsThroughDirectDepositDialog$render$slambdaClass_0;
}
function CollectFundsThroughDirectDepositDialog$render$slambda_2(this$0) {
  var i = new (CollectFundsThroughDirectDepositDialog$render$slambda_1())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function CollectFundsThroughDirectDepositDialog$render$lambda($this$option) {
  return false;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var CollectFundsThroughDirectDepositDialog$render$slambdaClass_1;
function CollectFundsThroughDirectDepositDialog$render$slambda_3() {
  if (CollectFundsThroughDirectDepositDialog$render$slambdaClass_1 === VOID) {
    class $ {
      constructor($$this$button, this$0, $inProgress) {
        this.ai8_1 = $$this$button;
        this.bi8_1 = this$0;
        this.ci8_1 = $inProgress;
      }
      wah($this$Action, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$Action), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CollectFundsThroughDirectDepositDialog$render$slambdaClass_1 = $;
  }
  return CollectFundsThroughDirectDepositDialog$render$slambdaClass_1;
}
function CollectFundsThroughDirectDepositDialog$render$slambda_4($$this$button, this$0, $inProgress) {
  var i = new (CollectFundsThroughDirectDepositDialog$render$slambda_3())($$this$button, this$0, $inProgress);
  var l = ($this$Action, $completion) => i.wah($this$Action, $completion);
  l.$arity = 1;
  return l;
}
var CollectFundsThroughDirectDepositDialog$render$slambdaClass_2;
function CollectFundsThroughDirectDepositDialog$render$slambda_5() {
  if (CollectFundsThroughDirectDepositDialog$render$slambdaClass_2 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CollectFundsThroughDirectDepositDialog$render$slambdaClass_2 = $;
  }
  return CollectFundsThroughDirectDepositDialog$render$slambdaClass_2;
}
function CollectFundsThroughDirectDepositDialog$render$slambda_6() {
  var i = new (CollectFundsThroughDirectDepositDialog$render$slambda_5())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
function CollectFundsThroughDirectDepositDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option$lambda_eyqlxo($this$icon) {
  $this$icon.xb8(false);
  return Unit_instance;
}
var CollectFundsThroughDirectDepositDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option$slambda_zhbtfClass;
function CollectFundsThroughDirectDepositDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option$slambda_zhbtf() {
  if (CollectFundsThroughDirectDepositDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option$slambda_zhbtfClass === VOID) {
    class $ {
      constructor($this$0, $option) {
        this.ei8_1 = $this$0;
        this.fi8_1 = $option;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CollectFundsThroughDirectDepositDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option$slambda_zhbtfClass = $;
  }
  return CollectFundsThroughDirectDepositDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option$slambda_zhbtfClass;
}
function CollectFundsThroughDirectDepositDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option$slambda_zhbtf_0($this$0, $option) {
  var i = new (CollectFundsThroughDirectDepositDialog$render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option$slambda_zhbtf())($this$0, $option);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var CollectFundsThroughDirectDepositDialogClass;
function CollectFundsThroughDirectDepositDialog() {
  if (CollectFundsThroughDirectDepositDialogClass === VOID) {
    class $ {
      constructor(amount, recipientInfo) {
        amount = amount === VOID ? Companion_instance.p91(0n) : amount;
        this.si7_1 = amount;
        this.ti7_1 = recipientInfo;
        this.ui7_1 = Signal().fak(PaymentTransferMethod_TwoThreeDay_getInstance());
      }
      di8() {
        return this.ti7_1.di8();
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(CollectFundsThroughDirectDepositDialog$render$slambda_0());
        view.eba(get_AppDimensions().wg1_1);
        var tmp = get_centered(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        launch(view_0, VOID, VOID, CollectFundsThroughDirectDepositDialog$render$slambda_2(this));
        var tmp_0 = view_0.ibb(sizeConstraints(view_0, VOID, VOID, VOID, VOID, VOID, get_rem(28)), view_0.hbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        view_1.zb8(get_AppDimensions().xg1_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(true);
        view_2.hba(Edges().cd0(get_AppDimensions().xg1_1, get_px(0)));
        title(view_2, 'Collect');
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.ebb(p_3, view_3);
        view_3.xbm(false);
        view_3.zb8(get_px(0));
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'Total available funds: ';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.ebb(p_4, view_4);
        view_4.jba(view_4.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_1 = view_4.tb5_1;
        var tmp_2;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_2 = '\xA0';
        } else {
          tmp_2 = content;
        }
        tmp_1.fbu(tmp_2);
        view_3.fbb(p_4, view_4);
        var tmp_3 = view_3.ibb(colored(view_3, AppColors_getInstance().dfz_1.xg9_1), get_bold(view_3));
        // Inline function 'com.crowpay.views.theming.boldSubTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (TextView())(view_3.pc());
        var tmp0_elvis_lhs_5 = view_3.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
        view_3.ebb(p_5, view_5);
        view_5.jba(view_5.ob6_1.ybe(SubtitleSemantic_getInstance().ybe(BoldSemantic_getInstance())));
        var tmp_4 = KMutableProperty0();
        var tmp_5 = TextView$_get_content_$ref_4pzcwl(view_5);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb(view_5));
        reactiveScope(view_5, ($this$reactiveScope) => {
          var tmp$ret$6 = MonetaryValue__toString_impl_xslc77(this.si7_1);
          this_0.set(tmp$ret$6);
          return Unit_instance;
        });
        view_3.fbb(p_5, view_5);
        view_3.jbb(tmp_3, view_5);
        view_2.fbb(p_3, view_3);
        view_1.fbb(p_2, view_2);
        greySeparator(view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_6 = view_1.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_1 : tmp0_elvis_lhs_6;
        view_1.ebb(p_6, view_6);
        view_6.xbm(true);
        view_6.hba(Edges().cd0(get_AppDimensions().xg1_1, get_px(0)));
        boldSubTitle(view_6, 'Where We Will Send Your Money');
        var tmp_6 = view_6.ibb(shownWhen(view_6, VOID, ($this$shownWhen) => $this$shownWhen.baj(this.di8()) == null), view_6.hbb(NothingHereSemantic_getInstance()));
        // Inline function 'com.crowpay.views.theming.body' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextView())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.ebb(p_7, view_7);
        view_7.jba(view_7.ob6_1.ybe(BodySemantic_getInstance()));
        var tmp_7 = KMutableProperty0();
        var tmp_8 = TextView$_get_content_$ref_4pzcwl_0(view_7);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_0(view_7));
        reactiveScope(view_7, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.baj(this.di8());
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.z9u_1;
          var tmp$ret$21 = tmp2_elvis_lhs == null ? 'No Account Connected' : tmp2_elvis_lhs;
          this_1.set(tmp$ret$21);
          return Unit_instance;
        });
        view_6.fbb(p_7, view_7);
        view_6.jbb(tmp_6, view_7);
        var tmp_9 = view_6.ibb(shownWhen(view_6, VOID, ($this$shownWhen) => !($this$shownWhen.baj(this.di8()) == null)), get_compact(view_6));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view_6.pc());
        var tmp0_elvis_lhs_8 = view_6.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
        view_6.ebb(p_8, view_8);
        view_8.xbm(false);
        view_8.jbb(get_centered(view_8), icon(view_8, resize(get_bank(Companion_getInstance()), get_rem_0(1.1)), 'account'));
        var tmp_10 = view_8.ibb(get_centered(view_8), get_expanding(view_8));
        // Inline function 'com.crowpay.views.theming.bodyBold' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (TextView())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.ebb(p_9, view_9);
        view_9.jba(view_9.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
        var tmp_11 = KMutableProperty0();
        var tmp_12 = TextView$_get_content_$ref_4pzcwl_1(view_9);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb_1(view_9));
        reactiveScope(view_9, ($this$reactiveScope) => {
          var tmp0_safe_receiver = $this$reactiveScope.baj(this.di8());
          var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y9t_1;
          var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.a9v_1;
          var tmp$ret$28 = tmp2_elvis_lhs == null ? '' : tmp2_elvis_lhs;
          this_2.set(tmp$ret$28);
          return Unit_instance;
        });
        view_8.fbb(p_9, view_9);
        view_8.jbb(tmp_10, view_9);
        view_6.fbb(p_8, view_8);
        view_6.jbb(tmp_9, view_8);
        var tmp_13 = PaymentTransferMethod_SameDay_getInstance();
        var tmp_14 = get_lightningBolt(Companion_getInstance());
        render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option_ieysnz(view_6, this, tmp_13, tmp_14, 'Same Day', '(Not yet available)', CollectFundsThroughDirectDepositDialog$render$lambda);
        var tmp_15 = PaymentTransferMethod_TwoThreeDay_getInstance();
        var tmp_16 = get_bank(Companion_getInstance());
        render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$option_ieysnz(view_6, this, tmp_15, tmp_16, '2-3 Days', 'No Fee', ($this$option) => !($this$option.baj(this.di8()) == null));
        view_1.fbb(p_6, view_6);
        var inProgress = Signal().fak(false);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var tmp_17 = view_1.hbb(ButtonSemantic_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.affirmative' call
        var tmp$ret$44 = view_1.hbb(AffirmativeSemantic_getInstance());
        var tmp_18 = view_1.ibb(tmp_17, tmp$ret$44);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_10 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_10 = view_1.cbb_1;
        var p_10 = tmp0_elvis_lhs_10 == null ? view_1 : tmp0_elvis_lhs_10;
        view_1.ebb(p_10, view_10);
        var tmp_19 = KMutableProperty0();
        var tmp_20 = Button$_get_enabled_$ref_61t7nx(view_10);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_3 = getPropertyCallableRef('enabled', 0, tmp_19, tmp_20, Button$_set_enabled_$ref_o8kynz(view_10));
        reactiveScope(view_10, ($this$reactiveScope) => {
          var tmp$ret$45 = !($this$reactiveScope.baj(this.di8()) == null) && !$this$reactiveScope.baj(inProgress);
          this_3.set(tmp$ret$45);
          return Unit_instance;
        });
        view_10.jbb(get_centered(view_10), bodyBold(view_10, 'Transfer'));
        view_10.mbg(Action('Transfer money out of Stoze', VOID, CollectFundsThroughDirectDepositDialog$render$slambda_4(view_10, this, inProgress)));
        view_1.fbb(p_10, view_10);
        view_1.jbb(tmp_18, view_10);
        view_0.fbb(p_1, view_1);
        view_0.jbb(tmp_0, view_1);
        var tmp_21 = get_atTopEnd(view_0);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var tmp$ret$54 = view_0.hbb(ButtonSemantic_getInstance());
        var tmp_22 = view_0.ibb(view_0.ibb(tmp_21, tmp$ret$54), view_0.hbb(GreyedOutSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_11 = new (Button())(view_0.pc());
        var tmp0_elvis_lhs_11 = view_0.cbb_1;
        var p_11 = tmp0_elvis_lhs_11 == null ? view_0 : tmp0_elvis_lhs_11;
        view_0.ebb(p_11, view_11);
        icon(view_11, Companion_getInstance().tcf_1, 'close');
        onClick(view_11, VOID, VOID, CollectFundsThroughDirectDepositDialog$render$slambda_6());
        view_0.fbb(p_11, view_11);
        view_0.jbb(tmp_22, view_11);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'CollectFundsThroughDirectDepositDialog', VOID, VOID, [Page()]);
    CollectFundsThroughDirectDepositDialogClass = $;
  }
  return CollectFundsThroughDirectDepositDialogClass;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.li8_1.ki8_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.li8_1.ji8_1.mi8(tmp$ret$0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = get_dialogStack();
  tmp_1.ebw(GenericDialog().bgh('Disbursement Requested', 'Your request has been submitted. You will receive a confirmation email with details.\n\nYour check will be mailed within 30 business days.', VOID, CollectFundsThroughPhysicalCheckDialog$render$slambda$slambda$slambda_0()));
  return Unit_instance;
}
var CollectFundsThroughPhysicalCheckDialog$render$slambda$slambda$slambdaClass;
function CollectFundsThroughPhysicalCheckDialog$render$slambda$slambda$slambda() {
  if (CollectFundsThroughPhysicalCheckDialog$render$slambda$slambda$slambdaClass === VOID) {
    class $ {
      wgg($this$GenericDialog, $completion) {
        get_dialogStack().ugg();
      }
      s2(p1, $completion) {
        return this.wgg(p1 instanceof ViewWriter() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    CollectFundsThroughPhysicalCheckDialog$render$slambda$slambda$slambdaClass = $;
  }
  return CollectFundsThroughPhysicalCheckDialog$render$slambda$slambda$slambdaClass;
}
function CollectFundsThroughPhysicalCheckDialog$render$slambda$slambda$slambda_0() {
  var i = new (CollectFundsThroughPhysicalCheckDialog$render$slambda$slambda$slambda())();
  var l = ($this$GenericDialog, $completion) => i.wgg($this$GenericDialog, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_4($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.ni8_1.ki8_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var request = tmp;
  var tmp_0 = 'A check for ' + MonetaryValue__toFullString_impl_igjjwy($this.ni8_1.ii8_1) + ' will be mailed to ' + request.x7y_1 + ' at ' + request.y7y_1.toString() + '. Checks typically arrive within 30 business days.';
  confirmationDialog($this.oi8_1, 'Confirm Check Delivery', tmp_0, 'Confirm', VOID, VOID, VOID, false, VOID, VOID, CollectFundsThroughPhysicalCheckDialog$render$slambda$slambda_0($this.ni8_1));
  return Unit_instance;
}
var CollectFundsThroughPhysicalCheckDialog$render$slambda$slambdaClass;
function CollectFundsThroughPhysicalCheckDialog$render$slambda$slambda() {
  if (CollectFundsThroughPhysicalCheckDialog$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.li8_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CollectFundsThroughPhysicalCheckDialog$render$slambda$slambdaClass = $;
  }
  return CollectFundsThroughPhysicalCheckDialog$render$slambda$slambdaClass;
}
function CollectFundsThroughPhysicalCheckDialog$render$slambda$slambda_0(this$0) {
  var i = new (CollectFundsThroughPhysicalCheckDialog$render$slambda$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function CollectFundsThroughPhysicalCheckDialog$request$lambda($this$mutableRemember) {
  var self_0 = $this$mutableRemember.eaj($this$mutableRemember.baj(get_session()).pfw_1);
  return new (Request())(get_fullName(self_0), self_0.l88_1);
}
var CollectFundsThroughPhysicalCheckDialog$render$slambdaClass;
function CollectFundsThroughPhysicalCheckDialog$render$slambda() {
  if (CollectFundsThroughPhysicalCheckDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CollectFundsThroughPhysicalCheckDialog$render$slambdaClass = $;
  }
  return CollectFundsThroughPhysicalCheckDialog$render$slambdaClass;
}
function CollectFundsThroughPhysicalCheckDialog$render$slambda_0() {
  var i = new (CollectFundsThroughPhysicalCheckDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var CollectFundsThroughPhysicalCheckDialog$render$slambdaClass_0;
function CollectFundsThroughPhysicalCheckDialog$render$slambda_1() {
  if (CollectFundsThroughPhysicalCheckDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $$this$button) {
        this.ni8_1 = this$0;
        this.oi8_1 = $$this$button;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CollectFundsThroughPhysicalCheckDialog$render$slambdaClass_0 = $;
  }
  return CollectFundsThroughPhysicalCheckDialog$render$slambdaClass_0;
}
function CollectFundsThroughPhysicalCheckDialog$render$slambda_2(this$0, $$this$button) {
  var i = new (CollectFundsThroughPhysicalCheckDialog$render$slambda_1())(this$0, $$this$button);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var CollectFundsThroughPhysicalCheckDialog$render$slambdaClass_1;
function CollectFundsThroughPhysicalCheckDialog$render$slambda_3() {
  if (CollectFundsThroughPhysicalCheckDialog$render$slambdaClass_1 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    CollectFundsThroughPhysicalCheckDialog$render$slambdaClass_1 = $;
  }
  return CollectFundsThroughPhysicalCheckDialog$render$slambdaClass_1;
}
function CollectFundsThroughPhysicalCheckDialog$render$slambda_4() {
  var i = new (CollectFundsThroughPhysicalCheckDialog$render$slambda_3())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var CollectFundsThroughPhysicalCheckDialogClass;
function CollectFundsThroughPhysicalCheckDialog() {
  if (CollectFundsThroughPhysicalCheckDialogClass === VOID) {
    class $ {
      constructor(amount, recipientInfo) {
        amount = amount === VOID ? Companion_instance.p91(0n) : amount;
        this.ii8_1 = amount;
        this.ji8_1 = recipientInfo;
        var tmp = this;
        tmp.ki8_1 = validated(mutableRemember(VOID, VOID, CollectFundsThroughPhysicalCheckDialog$request$lambda));
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(CollectFundsThroughPhysicalCheckDialog$render$slambda_0());
        var tmp = view.ibb(view.ibb(get_centered(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(40))), view.hbb(DialogSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.xbm(true);
        title(view_0, 'Confirm Check Delivery');
        body(view_0, 'A check for ' + MonetaryValue__toString_impl_xslc77(this.ii8_1) + ' will be mailed to:');
        // Inline function 'com.crowpay.views.components.requiredField' call
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(true);
        view_1.zb8(get_AppDimensions().ng2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        view_2.xbm(false);
        view_2.zb8(get_AppDimensions().pg2_1);
        view_2.jbb(get_centered(view_2), bodyBold(view_2, 'Name'));
        view_2.jbb(colored(view_2, AppColors_getInstance().hfz_1.xg9_1), bodyBold(view_2, '*'));
        view_1.fbb(p_2, view_2);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_0 = view_1.hbb(FieldSemantic_getInstance());
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_0 = this.ki8_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_1 = serializerOrContextual(createKType(getKClass(Request()), arrayOf([]), false));
        var tmp$ret$5 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
        var it = new (DataClassPathSelf())(tmp$ret$5);
        var tmp$ret$7 = get_name(it);
        var tmp$ret$8 = lensPath(this_0, tmp$ret$7);
        var name = assertNotBlank(tmp$ret$8);
        var tmp_2 = validate(view_1, name);
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (TextInput())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.ebb(p_3, view_3);
        view_3.xah(view_3.gcn_1, name);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value = 'Recipient Name';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_3.tb5_1.zb3_1.ib7_1.placeholder = value;
        view_1.fbb(p_3, view_3);
        view_1.jbb(tmp_2, view_3);
        var tmp$ret$14 = issueText(view_1, get_issues(name));
        view_1.jbb(tmp_0, tmp$ret$14);
        view_0.fbb(p_1, view_1);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextView())(view_0.pc());
        var tmp0_elvis_lhs_4 = view_0.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
        view_0.ebb(p_4, view_4);
        view_4.jba(view_4.ob6_1.ybe(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_3 = view_4.tb5_1;
        var tmp_4;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength('Address') === 0) {
          tmp_4 = '\xA0';
        } else {
          tmp_4 = 'Address';
        }
        tmp_3.fbu(tmp_4);
        view_0.fbb(p_4, view_4);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_1 = this.ki8_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_5 = serializerOrContextual(createKType(getKClass(Request()), arrayOf([]), false));
        var tmp$ret$26 = isInterface(tmp_5, KSerializer()) ? tmp_5 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$26);
        var tmp$ret$28 = get_address(it_0);
        var tmp$ret$29 = lensPath(this_1, tmp$ret$28);
        addressForm(view_0, tmp$ret$29);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Space())(view_0.pc(), 0.5);
        var tmp0_elvis_lhs_5 = view_0.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_0 : tmp0_elvis_lhs_5;
        view_0.ebb(p_5, view_5);
        view_0.fbb(p_5, view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_6 = view_0.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_0 : tmp0_elvis_lhs_6;
        view_0.ebb(p_6, view_6);
        view_6.xbm(false);
        view_6.zb8(get_AppDimensions().ig2_1);
        var tmp_6 = get_primaryButton(view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Button())(view_6.pc());
        var tmp0_elvis_lhs_7 = view_6.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_6 : tmp0_elvis_lhs_7;
        view_6.ebb(p_7, view_7);
        var tmp_7 = KMutableProperty0();
        var tmp_8 = Button$_get_enabled_$ref_61t7nx_1(view_7);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_2 = getPropertyCallableRef('enabled', 0, tmp_7, tmp_8, Button$_set_enabled_$ref_o8kynz_1(view_7));
        reactiveScope(view_7, ($this$reactiveScope) => {
          var tmp$ret$33 = $this$reactiveScope.baj(get_issues(this.ki8_1)).i1();
          this_2.set(tmp$ret$33);
          return Unit_instance;
        });
        specCenteredText(view_7, 'Confirm');
        onClick(view_7, VOID, VOID, CollectFundsThroughPhysicalCheckDialog$render$slambda_2(this, view_7));
        view_6.fbb(p_7, view_7);
        view_6.jbb(tmp_6, view_7);
        var tmp_9 = get_textButton(view_6);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (Button())(view_6.pc());
        var tmp0_elvis_lhs_8 = view_6.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view_6 : tmp0_elvis_lhs_8;
        view_6.ebb(p_8, view_8);
        specCenteredText(view_8, 'Go Back');
        onClick(view_8, VOID, VOID, CollectFundsThroughPhysicalCheckDialog$render$slambda_4());
        view_6.fbb(p_8, view_8);
        view_6.jbb(tmp_9, view_8);
        view_0.fbb(p_6, view_6);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'CollectFundsThroughPhysicalCheckDialog', VOID, VOID, [Page()]);
    CollectFundsThroughPhysicalCheckDialogClass = $;
  }
  return CollectFundsThroughPhysicalCheckDialogClass;
}
//region block: exports
export {
  CollectFundsThroughDirectDepositDialog as CollectFundsThroughDirectDepositDialog3q4mipmgpm4q8,
  CollectFundsThroughPhysicalCheckDialog as CollectFundsThroughPhysicalCheckDialog3f44xr2mvj2de,
};
//endregion

//# sourceMappingURL=CollectFunds.mjs.map
